import { parseText } from "./parseText.js";
export default function parseLastName(source) {
    const parsed = parseText(source.replace(/<{2}.*$/, ''), 0, /^[A-Z<]*<*$/);
    return {
        value: parsed,
        start: 0,
        end: parsed.length,
    };
}
//# sourceMappingURL=parseLastName.js.map